import { WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';
import { WorkoutDifficultyLevel, WorkoutDifficultyScale } from '../../types/workout-difficulty.type';

/** Niveaux de difficulte, du plus facile au plus dur. */
export const DIFFICULTY_LEVELS: readonly WorkoutDifficultyLevel[] = ['easy', 'medium', 'intermediate', 'hard', 'expert'];

/**
 * ? Les valeurs par défaut par modes pour les difficultés.
 */
export const DEFAULT_DIFFICULTY_SCALE_BY_MODE: Readonly<Record<WorkoutMode, Readonly<WorkoutDifficultyScale>>> = {
    ftp: { easy: 75, medium: 89, intermediate: 100, hard: 119 },
    watts: { easy: 127, medium: 173, intermediate: 219, hard: 276 },
    res: { easy: 37, medium: 53, intermediate: 69, hard: 84 },
    slope: { easy: -15, medium: 2, intermediate: 5, hard: 8 },
    inc: { easy: -2, medium: 2, intermediate: 5, hard: 8 },
    spd: { easy: 7, medium: 10, intermediate: 13, hard: 15 },
    incSpd: { easy: 7, medium: 10, intermediate: 13, hard: 15 },
};

export const DIFFICULTY_LEVEL_COLORS: Readonly<Record<WorkoutDifficultyLevel, string>> = {
    easy: 'var(--accent-easy, #428ff3)',
    medium: 'var(--accent-medium, #57c063)',
    intermediate: 'var(--accent-intermediate, #ffd46c)',
    hard: 'var(--accent-hard, #ffa34f)',
    expert: 'var(--accent-expert, #e55f58)',
};
